<app-form-input
  [id]="triggerId"
  class="form-autocomplete-trigger"
  [hasError]="hasError"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [tabindex]="tabindex"
  [inputStyle]="inputStyle"
  [inputIconType]="inputIcon"
  [attr.aria-labelledby]="triggerId"
  [ariaLabel]="ariaLabel"
  (focusInput)="focusInput.emit()"
  [(ngModel)]="value"
  (ngModelChange)="emitValue($event)"
  (rightButtonClick)="clearInput.emit()"
  [rightButtonAriaLabel]="'a11y.autocomplete.button.clear' | translate"
  [rightButtonIconType]="iconType.Close"
></app-form-input>
